import { combineReducers } from 'redux'
import misc from './misc'
import vacation from './vacation'

export default combineReducers({
  misc,
  vacation,
})
